export const sidebarLinks = [
    {
        imgURL: '/images/svg/home.svg',
        route: '/',
        label: 'Home',
    },
    {
        imgURL: '/images/svg/products.svg',
        route: '/products',
        label: 'Products',
    },
    {
        imgURL: '/images/svg/price-ticket.svg',
        route: '/pricing',
        label: 'Pricing',
    },
    {
        imgURL: '/images/svg/blog.svg',
        route: '/blog',
        label: 'Blog',
    },
    {
        imgURL: '/images/svg/contact.svg',
        route: '/contact',
        label: 'Contact',
    },
]

export const FOLDERS = {
    PUBLIC_UPLOADS_TEMPFILES: 'public/uploads/tempfiles',
    PUBLIC_UPLOADS_POST: 'public/uploads/post',
}

export const COOKIES = {
    TOAST_MESSAGE: 'toast-message',
}

export const RECAPTCHA_ACTIONS = {
    CONTACT_FORM: 'contact_form',
    NEWSLETTER_FORM: 'newsletter_form',
    SIGN_UP: 'sign_up',
    SIGN_IN: 'sign_in',
}
